import { CheckCircle2, AlertTriangle, XCircle, HelpCircle } from "lucide-react";

const MAP = {
  green: { bg: "#D1FAE5", text: "#065F46", icon: CheckCircle2, label: "Kemungkinan Cocok" },
  yellow: { bg: "#FEF3C7", text: "#92400E", icon: AlertTriangle, label: "Perlu Perhatian" },
  red: { bg: "#FEE2E2", text: "#991B1B", icon: XCircle, label: "Tidak Direkomendasikan" },
  grey: { bg: "#F1F5F9", text: "#475569", icon: HelpCircle, label: "Data Belum Cukup" },
};

export function TrafficLight({ status = "grey", label, className = "", size = "md" }) {
  const cfg = MAP[status] || MAP.grey;
  const Icon = cfg.icon;
  const pad = size === "lg" ? "px-4 py-2 text-base" : "px-3 py-1.5 text-sm";
  return (
    <span
      data-testid={`traffic-light-${status}`}
      className={`inline-flex items-center gap-2 rounded-full font-semibold ${pad} ${className}`}
      style={{ backgroundColor: cfg.bg, color: cfg.text }}
    >
      <Icon className="w-4 h-4" strokeWidth={2.2} />
      {label || cfg.label}
    </span>
  );
}
